export default __webpack_public_path__ + "static/media/exchange.78bbe0f8.svg";